var t="aptos:account";export{t as a};
//# sourceMappingURL=chunk-EKJ7Y4LP.mjs.map